import { render, staticRenderFns } from "./beoffice.vue?vue&type=template&id=15b082a8&scoped=true"
import script from "./beoffice.vue?vue&type=script&lang=js"
export * from "./beoffice.vue?vue&type=script&lang=js"
import style0 from "./beoffice.vue?vue&type=style&index=0&id=15b082a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b082a8",
  null
  
)

export default component.exports